import { useId } from 'react';
import styled from 'styled-components';
import { space } from '../../../../styles/onboardingUiTokens';
import { BottomDrawer } from '../elements/BottomDrawer';
import { Body } from '../typography/Body';
import { H3 } from '../typography/HeadingLevels';

export type LiabilityLegalDrawerProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  text: string;
};

const TextBlock = styled(Body)`
  white-space: pre-wrap;
  margin-bottom: ${space.lg};
`;

export function LiabilityLegalDrawer({ open, onClose, title, text }: LiabilityLegalDrawerProps) {
  const titleId = useId();

  return (
    <BottomDrawer open={open} onClose={onClose} aria-labelledby={titleId} gap={space.md}>
      <H3 id={titleId}>{title}</H3>
      <TextBlock variant="document" tone="muted">
        {text}
      </TextBlock>
    </BottomDrawer>
  );
}
